import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { AppComponent } from '../../app.component';
import { DataService } from '../../services/DataService';
import { MsalService } from '@azure/msal-angular';
//import { NgbCarousel, NgbSlideEvent, NgbSlideEventSource,NgbCarouselConfig  } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'app-text-analysis',
    templateUrl: './text-analysis.component.html',
    styleUrls: ['./text-analysis.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TextAnalysisComponent implements OnInit {
  private storage: any;
  username:any=''
  ShowLoader :string = "none";
  componentList=[{'component':'app-job-profile-matching','title':'Job Profile Matching','description':'Machine Learning and AI enabled algorithm to generate match score corresponding to job descriptions under radar','imageSrc':'../../../assets/images/textanalysis.png','status':'active'},
  //{'component':'app-speech-tagging','title':'Part of Speech tagging','description':'Option to generate part of speech tagging that will enable user in quickly understanding the various part of speech components that exists in long data which in turn helps in quick decision making','imageSrc':'../../../assets/images/textanalysis.png','status':'active'},
  {'component':'app-name-entity-recognition','title':'Name Entity Recognition','description':'Machine learning algorithm will help in automatically identifying the key entities that resides in large data','imageSrc':'../../../assets/images/textanalysis.png','status':'inactive'},
  {'component':'app-text-summarizer','title':'Text Summarizer','description':'Machine learning enabled  text summarizer which will help in summarizing large text data into few lines which help in understanding the gist quickly ','imageSrc':'../../../assets/images/textanalysis.png','status':'active'},
 /* {'component':'rebar-topic-modelling','title':'Theme Identification','description':'Machine learning will be used to generate key themes of the text data which will help in quick summarization of key hot spot areas around the subject ','imageSrc':'../../../assets/images/textanalysis.png','status':'inactive'},*/
  {'component':'app-theme-gen','title':'Theme Identification','description':'Machine learning will be used to generate key themes of the text data which will help in quick summarization of key hot spot areas around the subject ','imageSrc':'../../../assets/images/textanalysis.png','status':'inactive'},
  {'component':'rebar-wordcloud','title':'Word Cloud','description':'Leveraging text data word cloud will be generated which could be used to quickly grasp the key words in the text. Options like unigram, bi gram etc will be available','imageSrc':'../../../assets/images/textanalysis.png','status':'active'},
  {'component':'app-sentiment-analysis','title':'Sentiment Analysis','description':'Identifying sentiments hidden under long paragraphs, survey data, text data coming from various other sources. This will help in quickly understanding the key sentiment under category like positive, negative or neutral','imageSrc':'../../../assets/images/textanalysis.png','status':'inactive'}
  
]



  //FileSearch=false;
  
  /* Static data */ 

  constructor(
    private authService: MsalService,
     private api:DataService,      
    private app: AppComponent,
    //config:NgbCarouselConfig

    

) { this.storage = sessionStorage;
//   config.interval = 2000;
//   config.keyboard = true;
//   config.pauseOnHover = true; 
// config.pauseOnFocus=true;
// config.showNavigationIndicators=true;
// config.showNavigationArrows=true;
}
paused = false;
unpauseOnArrow = false;
pauseOnIndicator = false;
pauseOnHover = true;
pauseOnFocus = true;

// @ViewChild('carousel', {static : true}) carousel: NgbCarousel;

  ngOnInit(): void {
    var formData: any = new FormData();
    let auth_token=this.storage["msal.idtoken"];
    //this.username =this.authService.instance.getAllAccounts()[0].name;
    formData.append("auth_token", '');
    formData.append("username", this.authService.instance.getAllAccounts()[0].name);
    this.api.InsertUser_nlp(auth_token,formData).subscribe(
      
        (result: any) => {
        console.log('User inserted')

        }
    )

  }

  // togglePaused() {
  //   if (this.paused) {
  //     this.carousel.cycle();
  //   } else {
  //     this.carousel.pause();
  //   }
  //   this.paused = !this.paused;
  // }

  // onSlide(slideEvent: NgbSlideEvent) {
  //   if (this.unpauseOnArrow && slideEvent.paused &&
  //     (slideEvent.source === NgbSlideEventSource.ARROW_LEFT || slideEvent.source === NgbSlideEventSource.ARROW_RIGHT)) {
  //     this.togglePaused();
  //   }
  //   if (this.pauseOnIndicator && !slideEvent.paused && slideEvent.source === NgbSlideEventSource.INDICATOR) {
  //     this.togglePaused();
  //   }
  // }

 

  showComponent(comp: { component: any; }){
    //console.log('here in click');
    switch(comp.component){
      case 'app-job-profile-matching':
        this.app.ShowDiv('JobProfileMatching');
        break;
      case 'rebar-wordcloud':
        this.app.ShowDiv('WordCloud');
        break;
      // case 'rebar-topic-modelling':
      //   this.app.ShowDiv('TopicModelling');
      //   break;
      case 'app-text-summarizer':
        this.app.ShowDiv('TextSummarizer');
        break;
      case 'app-speech-tagging':
        this.app.ShowDiv('SpeechTagging');
        break;
      case 'app-sentiment-analysis':
        this.app.ShowDiv('SentimentAnalysis');
        break;
        case 'app-theme-gen':
        this.app.ShowDiv('ThemeGen');
        break;
      default:
        this.app.ShowDiv('TextAnalysis');
    }

    
  }
  new_showComponent(ncomp:any){
    this.app.ShowDiv(ncomp);
   
    
  }
}


